<template>
    <div>
        <div class="main-content">
            <!-- Filtros -->
            <div class="row mb-3">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                Filtros
                                <span
                                    data-toggle="collapse"
                                    href="#filtersCollapse"
                                    class="btn-filter"
                                    style="cursor: pointer"
                                >
                                    <i :class="showFilters ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                                </span>
                            </div>
                        </div>
                        <div class="card-body collapse show" id="filtersCollapse">
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label>ID</label>
                                        <input
                                            v-model="filters.id"
                                            type="text"
                                            class="form-control"
                                            placeholder="ID"
                                        />
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label>ID Reserva</label>
                                        <input
                                            v-model="filters.reserve_id"
                                            type="text"
                                            class="form-control"
                                            placeholder="ID Reserva"
                                        />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Placa Veículo</label>
                                        <input
                                            v-model="filters.vehicle_board"
                                            type="text"
                                            class="form-control"
                                            placeholder="Placa"
                                        />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Centro de Custos</label>
                                        <select
                                            v-model="filters.cost_center_id"
                                            class="form-control"
                                        >
                                            <option value="">Todos</option>
                                            <option
                                                v-for="cc in costCenters"
                                                :key="cc.id"
                                                :value="cc.id"
                                            >
                                                {{ cc.text }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label>Etapa</label>
                                        <select
                                            v-model="filters.step"
                                            class="form-control"
                                        >
                                            <option value="">Todas</option>
                                            <option value="2">Check-in</option>
                                            <option value="3">Check-out</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 text-right">
                                    <button
                                        @click="clearFilters"
                                        class="btn btn-secondary mr-2"
                                    >
                                        <i class="fas fa-eraser"></i> Limpar
                                    </button>
                                    <button
                                        @click="applyFilters"
                                        class="btn btn-primary"
                                    >
                                        <i class="fas fa-filter"></i> Filtrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                Não conformidades pendentes
                                <span
                                    data-toggle="collapse"
                                    href="#"
                                    @click="getDivergences"
                                    class="btn-filter"
                                    style="cursor: pointer"
                                >
                                    Atualizar
                                    <i class="fas fa-sync-alt"></i>
                                </span>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <table class="table table-hover">
                                        <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">ID Reserva</th>
                                            <th scope="col">Nome do Usuário</th>
                                            <th scope="col">Veículo</th>
                                            <th scope="col">Placa Veículo</th>
                                            <th scope="col">Centro de Custos</th>
                                            <th scope="col">Data</th>
                                            <th scope="col">Filial</th>
                                            <th scope="col">Etapa do Processo</th>
                                            <th scope="col">Ações</th>
                                        </tr>
                                        </thead>
                                        <tbody v-if="divergences.length > 0">
                                        <tr
                                            v-for="divergence in divergences"
                                            :key="divergence.id"
                                        >
                                            <td>{{ divergence.id }}</td>
                                            <td>{{ divergence.reserve_id }}</td>
                                            <td>{{ divergence.reserve && divergence.reserve.user ? divergence.reserve.user.name : '-' }}</td>
                                            <td>{{ divergence.reserve && divergence.reserve.vehicles ? divergence.reserve.vehicles.description : '-' }}</td>
                                            <td>{{ divergence.reserve && divergence.reserve.vehicles ? divergence.reserve.vehicles.board : '-' }}</td>
                                            <td>{{ divergence.reserve && divergence.reserve.vehicles && divergence.reserve.vehicles.costCenter ? divergence.reserve.vehicles.costCenter.description : 'Veículo Compartilhado' }}</td>
                                            <td>{{ divergence.created_at }}</td>
                                            <td>{{ divergence.reserve && divergence.reserve.branch ? divergence.reserve.branch.description : '-' }}</td>
                                            <td>
                                                {{ divergence.step == 2 ? "Check-in" : "Check-out" }}
                                            </td>
                                            <td>
                                                <button
                                                    type="button"
                                                    class="btn btn-crud view"
                                                    data-tooltip="tooltip"
                                                    title="Visualizar"
                                                    @click="openModals(divergence)"
                                                >
                                                    <i class="far fa-eye"></i>
                                                </button>
                                                <button
                                                    type="button"
                                                    class="btn btn-crud edit"
                                                    data-tooltip="tooltip"
                                                    title="Visualizar"
                                                    @click="change(divergence)"
                                                >
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                        <tbody v-else>
                                        <tr>
                                            <td
                                                colspan="10"
                                                align="center"
                                            >
                                                Nenhuma Não conformidade pendente de avaliação.
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div
                                class="row justify-content-center"
                                align="center"
                                style="padding: 15px"
                            >
                                <div class="col-md-12">
                                    <pagination
                                        :records="pendingTotal"
                                        :options="options"
                                        :per-page="15"
                                        @paginate="changePagePending"
                                    ></pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                Não conformidades
                                <span
                                    data-toggle="collapse"
                                    href="#"
                                    class="btn-filter"
                                >
                                    <toggle-button
                                        class="mt-1 mr-2"
                                        v-model="showFinisheds"
                                        @change="getDivergences()"
                                    />
                                    Exibir finalizados
                                </span>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <table class="table table-hover">
                                        <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">ID Reserva</th>
                                            <th scope="col">Nome do Usuário</th>
                                            <th scope="col">Veículo</th>
                                            <th scope="col">Placa Veículo</th>
                                            <th scope="col">Centro de Custos</th>
                                            <th scope="col">Data</th>
                                            <th scope="col">Filial</th>
                                            <th scope="col">Etapa do Processo</th>
                                            <th scope="col">Analisado Por</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Ações</th>
                                        </tr>
                                        </thead>
                                        <tbody v-if="finisheds.length > 0">
                                        <tr
                                            v-for="divergence in finisheds"
                                            :key="divergence.id"
                                        >
                                            <td>{{ divergence.id }}</td>
                                            <td>{{ divergence.reserve_id }}</td>
                                            <td>{{ divergence.reserve && divergence.reserve.user ? divergence.reserve.user.name : '-' }}</td>
                                            <td>{{ divergence.reserve && divergence.reserve.vehicles ? divergence.reserve.vehicles.description : '-' }}</td>
                                            <td>{{ divergence.reserve && divergence.reserve.vehicles ? divergence.reserve.vehicles.board : '-' }}</td>
                                            <td>{{ divergence.reserve && divergence.reserve.vehicles && divergence.reserve.vehicles.costCenter ? divergence.reserve.vehicles.costCenter.description : 'Veículo Compartilhado' }}</td>
                                            <td>{{ divergence.created_at }}</td>
                                            <td>{{ divergence.reserve && divergence.reserve.branch ? divergence.reserve.branch.description : '-' }}</td>
                                            <td>
                                                {{ divergence.step == 2 ? "Check-in" : "Check-out" }}
                                            </td>
                                            <td>{{ divergence.manager ? divergence.manager.name : '-' }}</td>
                                            <td>
                                                <h6 class="my-auto">
                                                    <span
                                                        :class="
                                                                divergence.status == 1
                                                                  ? 'badge badge-success'
                                                                  : (divergence.status == 2
                                                                  ? 'badge badge-primary'
                                                                  : 'badge badge-danger')
                                                              "
                                                    >{{
                                                            divergence.status == 1
                                                                ? "FINALIZADA"
                                                                : divergence.status == 2
                                                                    ? "EM ANDAMENTO"
                                                                    : "NÃO OK"
                                                     }}
                                                    </span
                                                    >
                                                </h6>
                                            </td>
                                            <td>
                                                <button
                                                    type="button"
                                                    class="btn btn-crud view"
                                                    data-tooltip="tooltip"
                                                    title="Visualizar"
                                                    @click="openModals(divergence)"
                                                >
                                                    <i class="far fa-eye"></i>
                                                </button>
                                                <button
                                                    type="button"
                                                    class="btn btn-crud edit"
                                                    data-tooltip="tooltip"
                                                    title="Visualizar"
                                                    @click="change(divergence)"
                                                >
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                        <tbody v-else>
                                        <tr>
                                            <td
                                                colspan="12"
                                                align="center"
                                            >
                                                Nenhuma Não conformidade pendente de avaliação.
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div
                                class="row justify-content-center"
                                align="center"
                                style="padding: 15px"
                            >
                                <div class="col-md-12">
                                    <pagination
                                        :records="finishedsTotal"
                                        :options="options"
                                        :per-page="15"
                                        @paginate="changePageFinished"
                                    ></pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ViewModalCheckIn
            :reserve="activeReserve"
            :modal-status="showVehicleModal"
            :show-button-user="false"
            @close="showVehicleModal = false"
        />

        <!-- Modal Moderação -->

        <DivergenceModal
            :reserve="activeReserve"
            :modal-status="showDivergenceModal"
            @close="showDivergenceModal = false"
            @change-divergence="changeDivergence"
            @save-observation="saveObservation"
        />

        <loading
            :active.sync="isLoading"
            :is-full-page="fullPage"
        ></loading>
    </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {Pagination} from "vue-pagination-2";
import {getMessage} from "../../composables/message";
import ViewModalCheckIn from "../ReserveVehicles/view-components/ViewModalCheckIn.vue";
import DivergenceModal from "../Modals/DivergenceModal.vue";

export default {
    data() {
        return {
            pendingPage: 1,
            finishedPage: 1,
            pendingTotal: 15,
            finishedsTotal: 15,
            options: {
                texts: {
                    count: "Mostrando {from} de {to} até {count} de registros",
                },
                chunk: 4,
                chunksNavigation: "fixed",
            },
            isLoading: true,
            fullPage: true,
            divergences: [],
            activeReserve: {},
            finisheds: [],
            dataDivergence: [],
            loadModalCheckout: false,
            loadModalCheckin: false,
            loadModalModeracao: false,
            showVehicleModal: false,
            showDivergenceModal: false,
            dataModal: [],
            ciCount: 0,
            imgs: [],
            observation: "",
            dataId: "",
            showFinisheds: false,
            showFilters: true,
            filters: {
                id: "",
                reserve_id: "",
                vehicle_board: "",
                cost_center_id: "",
                step: "",
            },
            costCenters: [],
        };
    },

    computed: {},
    methods: {
        changePagePending(page) {
            this.pendingPage = page;
            this.getDivergences();
        },
        changePageFinished(page) {
            this.finishedPage = page;
            this.getDivergences();
        },
        openModals(data) {
            this.activeReserve = data.reserve;
            this.dataDivergence = data;
            this.showVehicleModal = true;
        },
        change(data) {
            this.activeReserve = data.reserve;
            this.dataId = data.id;
            this.activeReserve.observations = data.observations;
            this.showDivergenceModal = true
        },
        changeDivergence: function (status) {
            const self = this;
            const api = self.$store.state.api + "divergences/change";

            self.$http
                .post(api, {
                    id: self.dataId,
                    status: status,
                    observation: self.observation,
                })
                .then(() => {
                    self.$message("Sucesso", `Dados atualizados`, "success");
                    this.showDivergenceModal = false;
                    self.getDivergences();
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        saveObservation: function (observation) {
            const self = this;
            const api = self.$store.state.api + "divergences/save-observation";

            self.$http
                .post(api, {
                    id: self.dataId,
                    observation,
                })
                .then(() => {
                    self.$message("Sucesso", `Observação registrada.`, "success");
                    this.showDivergenceModal = false;
                    self.getDivergences();
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        applyFilters() {
            this.pendingPage = 1;
            this.finishedPage = 1;
            this.getDivergences();
        },
        clearFilters() {
            this.filters = {
                id: "",
                reserve_id: "",
                vehicle_board: "",
                cost_center_id: "",
                step: "",
            };
            this.applyFilters();
        },
        getDivergences: function () {
            const self = this;

            const api =
                self.$store.state.api +
                "divergences/?pendingPage=" +
                self.pendingPage +
                "&finishedPage=" +
                self.finishedPage;

            self.isLoading = true;

            // Monta o payload com showFinisheds e filtros
            const payload = {
                showFinisheds: self.showFinisheds,
                ...self.filters
            };

            self.$http
                .post(api, payload)
                .then((response) => {
                    self.divergences = response.data.pending.data;
                    self.pendingTotal = response.data.pending.total;
                    self.finisheds = response.data.finisheds.data;
                    self.finishedsTotal = response.data.finisheds.total;
                    self.isLoading = false;
                    self.observation = "";
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        loadCostCenters() {
            const api = this.$store.state.api + 'cost-centers';
            this.$http.get(api, { params: { paginated: false, orderByAsc: 'erp_code' } })
                .then((response) => {
                    const costCenters = response.data.data || [];

                    // Adiciona opção "Veículo de Locação" para veículos sem centro de custos
                    this.costCenters = [
                        { id: '-1', text: 'Veículo de Locação' },
                        ...costCenters.map(cc => ({
                            id: cc.id,
                            text: cc.erp_code
                        }))
                    ];
                })
                .catch((error) => {
                    console.error('Erro ao carregar centros de custos:', error);
                });
        },
    },
    mounted: function () {
        const self = this;
        self.loadCostCenters();
        self.getDivergences();
    },
    components: {DivergenceModal, ViewModalCheckIn, Loading, Pagination},
};
</script>



// WEBPACK FOOTER //
// src/components/Divergences/Index.vue